import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'
import { useQuery } from 'libs/query'
import { useParams } from 'libs/router'
import { useContext } from 'react'
import { useAxiosPrivate } from 'shared/hooks'
import { HistoryRes } from 'shared/types/general.types'
import { AuthContext } from 'store'

export const useFetchPayoutHistory = () => {
	const params = useParams()
	const axiosPrivate = useAxiosPrivate()
	const { auth } = useContext(AuthContext)

	const { data: payoutHistory, isPending: isPayoutHistoryLoading } = useQuery<HistoryRes>({
		queryKey: queryKeys.payouts.history(params.id as string),
		queryFn: () => axiosPrivate.get(apiRoutes.payoutHistory(params.id as string)),
		enabled: !!auth.accessToken
	})

	return {
		payoutHistory,
		isPayoutHistoryLoading
	}
}
